<!--
 * @Description: 个体详情
                 22状态，个体户营业执照部分信息可编辑，保存按钮
                 21状态，个体户营业执照部分信息可编辑，审核按钮，放到代办供应商
                 OSS去掉21，代办供应商去掉11留21
                 只能添加园区个体
 * @Date: 2025-09-18 11:26:46
-->
<template>
  <div style="display: flex; flex-direction: column; padding: 0">
    <div style="flex: 1; height: 100%; overflow-y: auto">
      <!-- 经营者信息 -->
      <DetailOperator v-model="formData" />
      <div style="height: 16px; background: #f2f4f8"></div>

      <!-- 银行信息 -->
      <DetailBank v-model="formData" />
      <div style="height: 16px; background: #f2f4f8"></div>

      <!-- 提交材料 -->
      <DetailMaterial v-model="formData" />
      <div style="height: 16px; background: #f2f4f8"></div>

      <!-- 仅平台审核不展示 -->
      <template v-if="query.enterType !== 'platformAudit'">
        <!-- 个体户营业执照相关信息 -->
        <DetailLicense ref="detailLicenseRef" v-model="formData" />
        <div style="height: 16px; background: #f2f4f8"></div>

        <!-- 服务有效期 -->
        <DetailValidity
          ref="detailValidityRef"
          v-model="formData"
          @success="initValidity"
        />
        <div style="height: 16px; background: #f2f4f8"></div>
      </template>

      <!-- 平台审核 -->
      <template v-if="showPlatform">
        <DetailPlatform ref="detailPlatformRef" v-model="formData" />
        <div style="height: 16px; background: #f2f4f8"></div>
      </template>

      <!-- 园区审核 -->
      <template v-if="formData.auditStatus >= 21">
        <DetailPark v-model="formData" />
        <div style="height: 16px; background: #f2f4f8"></div>
      </template>
    </div>
    <div class="affix-box">
      <template v-if="query.enterType !== 'detail'">
        <template v-if="[21].includes(+formData.auditStatus)">
          <BaseButton type="default" @click="onCancel">取消</BaseButton>
          <BaseButton
            type="danger"
            @click="onTerminate"
            v-if="formData.individualType == 3"
          >
            终止
          </BaseButton>
          <BaseButton type="danger" @click="onReject">驳回</BaseButton>
          <!-- 客户个体复审叫提交，其他叫通过 -->
          <BaseButton type="primary" @click="onPass">
            {{ formData.individualType == 2 ? '提交' : '通过' }}
          </BaseButton>
        </template>
      </template>
      <template v-else>
        <BaseButton type="default" @click="onCancel">取消</BaseButton>
        <BaseButton
          v-if="[22].includes(+formData.auditStatus)"
          type="primary"
          @click="onSave"
        >
          保存
        </BaseButton>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BaseButton,
  useCreateModal,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import {
  DetailOperator,
  DetailBank,
  DetailMaterial,
  DetailValidity,
  DetailPlatform,
  DetailPark,
  DetailTerminateDialog,
  DetailLicense
} from '../components/detail';
import {
  individualInfoDetail,
  platformAudit,
  parkAudit,
  modifyIndividual
} from '../data-source/apis';
import { IndividualInfoDetailData } from '../data-source/types';
import { DetailRouteQuery } from '../types';
import { ENTER_TYPE } from '../constants';

const AUDIT_AJAX: {
  [key in DetailRouteQuery['enterType']]: any;
} = {
  platformAudit: platformAudit,
  parkAudit: parkAudit,
  detail: null
};

defineOptions({
  name: 'individual-household-detail'
});

const router = useRouter();
const query = useRoute().query as DetailRouteQuery;
const auditAjax = AUDIT_AJAX[query.enterType];

const detailLicenseRef = ref();
const detailValidityRef = ref();
const detailPlatformRef = ref();
const formData = ref<IndividualInfoDetailData>({
  individualName: '',
  businessParkName: '',
  idcard: '',
  cardId: '',
  operator: '',
  phone: '',
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  expiraStart: '',
  expiraEnd: '',
  enable: null,
  bankInfo: '',
  bankCardNum: '',
  registerAt: '',
  declareMethod: null,
  taxAssessmentMethod: null,
  invoiceType: null,
  invoiceItemIdList: [],
  historyExpiraDateList: [],
  cardIdFront: '',
  cardIdBack: '',
  additionalRemark: '',
  intentNameList: [],
  fileList: [],
  individualType: 3, // 只能添加园区个体户
  auditStatus: null,
  auditTerminationReason: '',
  auditTerminationRemark: '',
  id: null,
  createBy: '',
  updateBy: '',
  createAt: '',
  updateAt: '',
  deleted: null,
  _expira: [],
  _fileList: [],
  _invoiceType: [],
  businessParkId: 0,
  isSkipFile: 0,
  isPermanent: 0,
  businessScope: '',
  businessAddress: ''
});

const isGt2AuditStatus11 = computed(() => {
  return formData.value.auditStatus == 11 && formData.value.individualType == 2;
});
/*
  是否展示平台审核内容
    园区个体(3)审核中(11)不展示，其他都展示，无操作，有信息
    客户个体(2)审核中(11)展示，有操作，无信息
*/
const showPlatform = computed(() => {
  return isGt2AuditStatus11.value || formData.value.auditStatus != 11;
});

const initValidity = async () => {
  const { data } = await individualInfoDetail({
    businessIndividualId: +query.id
  });
  Object.assign(formData.value, {
    _expira: [data.expiraStart, data.expiraEnd],
    expiraStart: data.expiraStart,
    expiraEnd: data.expiraEnd,
    historyExpiraDateList: data.historyExpiraDateList
  });
};
const init = async () => {
  if (!query.id) {
    XrkMessage.error('参数错误');
    return;
  }
  if (!ENTER_TYPE.includes(query.enterType)) {
    XrkMessage.error('参数类型');
    router.go(-1);
    return;
  }
  const { data } = await individualInfoDetail({
    businessIndividualId: +query.id
  });
  formData.value = data;
};
const checkRefs = async () => {
  return Promise.all([
    detailLicenseRef.value.validate(),
    detailValidityRef.value.validate()
  ]);
};

// 终止
const onTerminate = () => {
  useCreateModal(DetailTerminateDialog, {
    id: query.id,
    auditAjax,
    onSuccess() {
      onCancel();
    }
  });
};
// 驳回
const onReject = async () => {
  const data = await XrkMessageBox.prompt('请输驳回原因', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    inputType: 'textarea',
    inputErrorMessage: '请输入1-200个字符',
    inputValidator(v) {
      const _v = v.trim();
      return _v.length > 0 && _v.length <= 200;
    }
  });
  await auditAjax({
    id: +query.id,
    status: 3,
    auditTerminationReason: data.value
  });
  XrkMessage.success('操作成功');
  onCancel();
};
const onPass = async () => {
  // 园区校验字段
  if (query.enterType == 'parkAudit') {
    await checkRefs();
  }
  // 客户校验
  if (query.enterType == 'platformAudit' && isGt2AuditStatus11.value) {
    await detailPlatformRef.value.validate();
  }
  XrkMessageBox.confirm('是否确认通过？', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认'
  }).then(async () => {
    await auditAjax({
      ...formData.value,
      id: +query.id,
      status: 2
    });
    XrkMessage.success('操作成功');
    onCancel();
  });
};
const onSave = async () => {
  await checkRefs();
  await modifyIndividual(formData.value);
  XrkMessage.success('保存成功');
  onCancel();
};
const onCancel = () => {
  router.go(-1);
};

onBeforeMount(async () => {
  init();
});
</script>
<style lang="scss" scoped>
::v-deep {
  .base_text_title {
    padding: 16px 24px 0;
    font-weight: 600 !important;
    font-size: 20px !important;
    color: #121619 !important;
    border: none !important;
  }

  .base_text_content {
    padding-bottom: 0;
  }
}
</style>
